import React from 'react';
import LinkedIn from '@material-ui/icons/LinkedIn';

export default function LinkedInIcon(props) {
    const { ...other } = props;

    return (
        <LinkedIn {...other} />
    );
}